export const CLEAR_DETAILS_USER = 'CLEAR_DETAILS_USER'